import { assetPath } from '@/libs/assetPath/assetPath';
import { fulfillmentPath } from '@/libs/fulfillmentPath/fulfillmentPath';
import { ParamsProps } from '@/libs/interfaceProps/paramsProps';

/**
 * Interface for validation parameters
 */
interface ValidationParams {
  peDemandSub?: boolean;
  customerLinks?: boolean;
  leadDropValidation?: boolean;
}

/**
 * Generates a smart form redirect URL based on various parameters
 * 
 * @param currentHostUrl - The base host URL
 * @param validationParams - Object containing validation parameters
 * @param resId - Resource ID
 * @param params - Object containing locale and other parameters
 * @param pathname - Current path name
 * @param queryParams - Query parameters to append to the URL
 * @returns The complete smart form redirect URL
 */
export const getSmartFormRedirectUrl = (currentHostUrl: string, validationParams: ValidationParams | undefined, resId: string, params: ParamsProps, pathname: string, queryParams: string): string => {
  // Base URL path
  const basePath = currentHostUrl + '/hub';

  // Determine the path based on validation parameters
  const path = validationParams?.peDemandSub === true ? assetPath({
    resId: resId,
    locale: params?.lang,
    c: pathname.includes('/c/'),
    peId: params.peId
  }) : fulfillmentPath({
    resId: resId,
    locale: params.lang
  });

  // Combine all parts to form the complete URL
  return basePath + path + queryParams;
};

/**
 * Example usage:
 * 
 * const smartFormRedirectUrl = getSmartFormRedirectUrl(
 *   'https://www.example.com',
 *   { peDemandSub: true },
 *   '12345',
 *   { lang: 'en', peId: '67890' },
 *   '/asset/path',
 *   '?utm_source=example'
 * );
 */